import axios from "axios";

const AUTH_STORAGE_KEYS = ["btoken", "rtoken", "userData", "userId", "addressId"];

export const clearAuthStorage = () => {
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  window.dispatchEvent(new Event("auth-session-changed"));
};

const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || "";
    const hadAuth = Boolean(error.config?.headers?.Authorization);
    const isLoginPage = window.location.pathname === "/login";
    const isAuthEndpoint = /\/auth\//.test(requestUrl);

    if (
      status === 401 &&
      hadAuth &&
      !isAuthEndpoint &&
      !isLoginPage
    ) {
      clearAuthStorage();
      window.location.assign("/login");
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
